/**
 * Helper functions for numbers
 */
class NumberUtils {
    /**
     *
     * @param {string} number
     * @return {string}
     */
    static toEnNumber(number) {
        const fa_digits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
        let temp_number = number;

        fa_digits.forEach((digit, index) => {
            temp_number = temp_number.replace(new RegExp(digit, "g"), index);
        });

        return temp_number;
    }

    /**
     * returns nth for a number in
     * @param {number} number
     * @return {string}
     */
    static toNth(number) {
        const nths = {
            1: "اول",
            2: "دوم",
            3: "سوم",
            4: "چهارم",
            5: "پنجم",
            6: "ششم",
            7: "هفتم",
            8: "هشتم",
            9: "نهم",
            10: "دهم",
            11: "یازدهم",
            12: "دوازدهم",
        };
        return nths[number];
    }
}

export default NumberUtils;
export { NumberUtils };
